/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { DataSet } from "vis-data";

export const FORM_DATA_BRAND_TYPE = "@vlinder:mintpad-onboard-user-brandtype";

export const formDataBrandTypeDs = new DataSet({
    fieldId: "id",
   
})


export const useFormDataBrandTypeDs = (data: any) => {
    formDataBrandTypeDs.update(data);
}